const TEST_CONTENT_FRAGMENT = `
<h1>Some HTML for Unit Testing</h1>
<p>Target the string __test__ with your unit test.</p>
<a href="1nrodlk">1nrodlk</a>`;

module.exports = TEST_CONTENT_FRAGMENT;